import Matching from "./Matching";
import matching_reducer from "./slice";
import matchingSaga, { MATCHING_SET_MERCHANTS_SAGA } from "./saga";
import { MerchantData, MerchandiseData, UsingMerchantData } from "./interface";

export default Matching;
export { matching_reducer, matchingSaga, MATCHING_SET_MERCHANTS_SAGA };
export type { MerchantData, MerchandiseData, UsingMerchantData };
